export const CHILD_TYPE = 'child';
export const HEADER_TYPE = 'header';
